import React from 'react'
import { useIntegrationProvider } from '../../providers'

const BeePixie = () => {
  const [integrationProvider, messageBus] = useIntegrationProvider()
  const divStyle = { height: '100%' }
  const pixie = React.useRef(null)
  const [config, setConfig] = React.useState(null)

  const resetEditor = () => {
    if (config?.image) {
      pixie.current.resetEditor('image', config?.image)
      pixie.current.getTool('export')
    }
  }

  const onInit = ({ config }) => {
    if (config) {
      pixie.current = new window.Pixie({
        ...config,
        onLoad: () => {
          // Legacy requirement to avoid updating the frontend config.
          integrationProvider.emit('onInit')
        }
      })
    }
  }

  const onLoad = (src) => {
    if (src) {
      setConfig(prevConfig => ({...prevConfig, image: src }))
    }
  }

  const onSave = () => {
    const imageData = pixie.current.getTool('export').getDataUrl()
    integrationProvider.emit('onSave', [imageData])
  }

  React.useEffect(() => {
    integrationProvider.emit('onReady')
    messageBus.on('init', onInit)
    messageBus.on('load', onLoad)
    messageBus.on('save', onSave)
    return () => {
      messageBus.off('init')
      messageBus.off('load')
      messageBus.off('save')
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    resetEditor()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config])

  return (
    <div style={divStyle}>
      <pixie-editor />
    </div>
  )
}

export default BeePixie
